import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import { compose } from 'recompose';
import { connect } from 'react-redux';

import { getIsLoggedIn } from '../../containers/Auth/selectors';
import { CentralSection, HeaderContainer, LeftSection, MacAppLink, RightSection } from '../Header';
import Logo from '../Logo';
import PATHS from '../../constants/paths';
import { FormattedMessage } from 'react-intl';
import MainNavItem from './MainNavItem';

import './styles.scss';
import { getAppStatus } from '../../containers/App/selectors';
import StreakNavItem from '../StreakNavbar/index';
import { getUserProfile } from '../../containers/UserProfile/selectors';

interface Props {
  className?: string;
}

interface ConnectedProps {
  isLoggedIn: boolean;
  appStatus: string;
  wasLoggedIn: boolean;
}

const enhance = compose<Props & ConnectedProps, Props>(
  withRouter,
  React.memo,
  connect(
    (state: any): ConnectedProps => {
      return {
        appStatus: getAppStatus(state),
        isLoggedIn: getIsLoggedIn(state),
        wasLoggedIn: getUserProfile(state).wasLoggedIn,
      };
    },
  ),
);

const MainHeader = (props: Props & ConnectedProps & RouteComponentProps) => {
  const authItemPath = props.isLoggedIn
    ? PATHS.USER_PROFILE.INDEX
    : props.wasLoggedIn
    ? PATHS.AUTH.SIGN_IN
    : PATHS.AUTH.SIGN_UP;

  const pathName = props.location.pathname;

  return (
    <HeaderContainer className={props.className}>
      <LeftSection>
        <Logo>
          <div className="Main-Status-Header">
            <p className="LogoTitle">Morning Pages</p>
            <span className="App-status">
              <FormattedMessage id={`appState.${props.appStatus}`} />
            </span>
          </div>
        </Logo>
      </LeftSection>
      <CentralSection>
        <MainNavItem to={PATHS.HOME} iconName="plus-outlined" activeIconName="plus" currentPathname={pathName} />
        <MainNavItem
          to={PATHS.STATISTICS.INDEX}
          iconName="statistics-outlined"
          activeIconName="statistics"
          currentPathname={pathName}
        />
        <MainNavItem
          to={PATHS.BADGES.INDEX}
          iconName="header-badges"
          activeIconName="header-badges-outlined"
          currentPathname={pathName}
        />
      </CentralSection>
      <RightSection>
        <MacAppLink />
        <StreakNavItem />
        <MainNavItem
          to={authItemPath}
          iconName="profile"
          activeIconName="profile-active"
          currentPathname={pathName}
          className="MainNav-item--auth"
        />
      </RightSection>
    </HeaderContainer>
  );
};

export default enhance(MainHeader);



// WEBPACK FOOTER //
// ./src/components/MainHeader/index.tsx